const STYLES = {
  delivered: "bg-[hsl(140_60%_45%)]/15 text-[hsl(140_60%_30%)] border-[hsl(140_60%_45%)]/40",
  sent: "bg-[hsl(200_80%_50%)]/15 text-[hsl(200_80%_35%)] border-[hsl(200_80%_50%)]/40",
  queued: "bg-[hsl(200_80%_50%)]/10 text-[hsl(200_80%_35%)] border-[hsl(200_80%_50%)]/30",
  accepted: "bg-[hsl(200_80%_50%)]/10 text-[hsl(200_80%_35%)] border-[hsl(200_80%_50%)]/30",
  sending: "bg-muted text-muted-foreground border-border",
  failed: "bg-destructive/10 text-destructive border-destructive/40",
  undelivered: "bg-destructive/10 text-destructive border-destructive/40",
  test_mode: "bg-[hsl(272_90%_55%)]/10 text-[hsl(272_80%_45%)] border-[hsl(272_90%_55%)]/40",
  skipped: "bg-muted text-muted-foreground border-border",
  pending: "bg-[hsl(40_90%_55%)]/15 text-[hsl(30_70%_32%)] border-[hsl(40_90%_55%)]/40",
  cancelled: "bg-muted text-muted-foreground border-border line-through",
  missed: "bg-destructive/10 text-destructive border-destructive/40",
};

const LABELS = { test_mode: "Test mode", pending: "Scheduled" };

export function SmsStatusBadge({ status }) {
  return (
    <span data-testid={`sms-status-${status}`}
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium capitalize ${STYLES[status] || STYLES.sending}`}>
      {LABELS[status] || status}
    </span>
  );
}
